import { ICityTaxAuto } from '../../../interfaces';

class CityTaxAutoMapper {
    toPersistence(domainCityTaxAuto: ICityTaxAuto): any {
        return {
            id: domainCityTaxAuto.id,
            app_user: domainCityTaxAuto.app_user,
            county_id: domainCityTaxAuto.county_id,
            installment_number: domainCityTaxAuto.installment_number,
            payment_date: domainCityTaxAuto.payment_date,
            payment_method: domainCityTaxAuto.payment_method,
            type: domainCityTaxAuto.type,
            created_at: domainCityTaxAuto.created_at,
            updated_at: domainCityTaxAuto.updated_at,
        }
    }

    toDomain(persistenceCityTaxAuto: any): ICityTaxAuto {
        return {
            id: persistenceCityTaxAuto.id,
            app_user: persistenceCityTaxAuto.app_user,
            county_id: persistenceCityTaxAuto.county_id,
            installment_number: persistenceCityTaxAuto.installment_number,
            payment_date: persistenceCityTaxAuto.payment_date,
            payment_method: persistenceCityTaxAuto.payment_method,
            property_code: persistenceCityTaxAuto.property_code,
            type: persistenceCityTaxAuto.type,
            created_at: persistenceCityTaxAuto.created_at,
            updated_at: persistenceCityTaxAuto.updated_at,
        }
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new CityTaxAutoMapper();
